import portfolioService from '@/services/portfolio.service.js';
import settingsService from '@/services/settings.service.js';
import c2ag2pService from '@/services/contact2access-group2portfolio.service.js';

const state = {
    portfolios: [],
    activePortfolio: {},
    maxAmountOfAllowedPortfolios: 999
}

const mutations = {
    SET_MAX_ALLOWED_PORTFOLIOS(state, maxAmountOfAllowedPortfolios){
        state.maxAmountOfAllowedPortfolios = maxAmountOfAllowedPortfolios;
    },
    SET_PORTFOLIOS(state, portfolios){
        state.portfolios = portfolios;
    },
    SET_PORTFOLIO_BY_ID(state, portfolio){
        const index = state.portfolios.findIndex(p => p.id == portfolio.id);
        state.portfolios[index] = portfolio;
    },
    SET_ACTIVE_PORTFOLIO(state, portfolio){
        state.activePortfolio = portfolio;
    },
    SET_ARTICLES(state, articles)
    {
        state.activePortfolio.articles = articles;
    }
}

const actions = {
    async fetchPortfolios({ commit, dispatch}){
        try {
            const userId = JSON.parse(localStorage.getItem('user')).user.id;
            const response = await c2ag2pService.getAllWhereUserId(userId);
            
            if(response.data && response.data.length > 0)
            {
                const portfolioIds = response.data.map(p => p.portfolio_id);
                const portfolios = await portfolioService.getMany(portfolioIds);
                
                let isOwnerOfPortfolio = false;
                let usersPortfolios = portfolios.data.filter(p => p.owner.id == userId);
                if (usersPortfolios.length === 1){
                    // Auto choose portfolio to the only one you own
                    await dispatch("setActivePortfolio", usersPortfolios[0].id);
                    isOwnerOfPortfolio = true;
                }
                const maxAmountOfAllowedPortfolios = (await settingsService.getOne("maxNumberOfPortfoliosPerUser")).setting;
                commit('SET_MAX_ALLOWED_PORTFOLIOS', maxAmountOfAllowedPortfolios);
                commit('SET_PORTFOLIOS', portfolios.data);
                return isOwnerOfPortfolio;
            }   
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        } 
    },
    async createNewPortfolio({ dispatch }){
        try{
            const userId = JSON.parse(localStorage.getItem('user')).user.id
            
            const userOwnedPortfolios = await portfolioService.getOwnedCount(userId)
           
            const maxAmountOfAllowedPortfolios = (await settingsService.getOne("maxNumberOfPortfoliosPerUser")).setting;
            if (userOwnedPortfolios >= maxAmountOfAllowedPortfolios){
                return;
            }
          
            let newPortfolio = await portfolioService.create(userId);
            if(newPortfolio.data){
                const portfolioId = newPortfolio.data.id;
                await dispatch("createContact", { portfolioId: portfolioId, userId: userId, isOwner: true, useMyPortfolioId: true });
                newPortfolio = await dispatch("setActivePortfolio", portfolioId);

                let payload = {
                    ownerId: userId,
                    isAboutMe: true,
                }
                await dispatch("createArticle", payload);
                
                newPortfolio = await dispatch("setActivePortfolio", portfolioId);
                return newPortfolio;
            }
        }
        catch(e){
            console.log(e);
        }
    },
    async setActivePortfolio({commit, dispatch, rootGetters}, portfolioId) {
        try {
            const response = await portfolioService.getOne(portfolioId);
            if(response.data?.portfolio)
            {
                await commit('SET_ACTIVE_PORTFOLIO', response.data.portfolio);     

                await dispatch('fetchAccessGroups');
                await dispatch('fetchContacts', response.data.portfolio.id);
                await dispatch('fetchArticleCategories');
                await dispatch('userAccount/fetchPortfolioOwner', response.data.portfolio.owner);
                
                const userId = rootGetters['userAccount/getUser'].id;
                const contactId = rootGetters.getContactByUserId(userId).id;
                const data = { portfolioId: portfolioId, contactId: contactId };

                await dispatch('fetchUserPermissions', data);
                await dispatch('setArticles', response.data.portfolio.articles);     
                // await dispatch('setEvents', response.data.portfolio.events);

                return response.data.portfolio;
            }  
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    },
    async updateArticles({commit, state}, articles)
    {
        if(!articles) return;

        try {
            commit('SET_ARTICLES', articles);
            portfolioService.update(state.activePortfolio);
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    },
    clearPortfolios({commit}){
        commit("SET_PORTFOLIOS", []);
        commit("SET_ACTIVE_PORTFOLIO", {});
    }
}

const getters = {
    getAllPortfolios: (state) =>{
        return state.portfolios;
    },
    getMaxAmountOfAllowedPortfolios: (state) => {
        return state.maxAmountOfAllowedPortfolios;
    },
    getPortfolioByArticleId: (state) => (articleId) => { 
        return state.portfolios.find(p => p.articles.find(a => a.id == articleId));
    },
    getActivePortfolio: (state) => {
        return state.activePortfolio;
    },
    isActivePortfolioBlocked: (state) => {
        return state.activePortfolio.blocked;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}